import * as ko from 'knockout';
import { P } from 'Core/Common/Promise';

import iFrame from './iFrame.html';
import { Brand } from 'Core/Common/Brand';
import { ILoginFormOnPageParams, UserMenu } from 'MenuManager/UserMenu/UserMenu';
import { EVENTS as GUEST_HOME_PAGE_EVENTS } from 'GuestHomePage/Events';
import { Event } from '../Core/Common/Event';

export const GuestPage = {
    FORM_ID: 'js-guest-page-form',
};

export interface IGuestHomePageParams {
    LoginViaUserMenu: boolean;
    LoginViaPlugin: boolean | null;
    OnlyLoginForm: boolean;
}

import Template from './Template.html';
ko.templates['Core/GuestHomePage/Template'] = Template;

export class GuestHomePage extends Event {
    private _container: HTMLElement;
    private _isReady: KnockoutObservable<boolean>;
    private _imageData: KnockoutObservable<string>;
    private _imageUrl: string;
    private _loginViaUserMenu: KnockoutObservable<boolean>;
    private _onlyLoginForm: KnockoutObservable<boolean>;
    private _loginViaPlugin: KnockoutObservable<boolean>;
    private _isDebugLoginForm: boolean = false; //remove in all places after fixing all bugs

    constructor(params: IGuestHomePageParams) {
        super();
        this._isReady = ko.observable(false);
        this._imageData = ko.observable(null);
        this._imageUrl = this.GetImageUrl();
        this._loginViaUserMenu = ko.observable(params?.LoginViaUserMenu);
        this._loginViaPlugin = ko.observable(params?.LoginViaPlugin);
        this._onlyLoginForm = ko.observable(params?.OnlyLoginForm);

        this._isDebugLoginForm && console.log('Constructor ---> Guest Home Page', params);
        this.AddEvent('LOGIN_VIA_PLUGIN');
    }

    GetTemplateName() {
        return 'Core/GuestHomePage/Template';
    }

    GetIFrame() {
        return iFrame;
    }

    GetImageUrl() {
        const subDomain = window.location.hostname.split('.')[0];
        var timestamp = +new Date();
        return `/Static/Images/${subDomain}/Guest.jpg?${timestamp}`;
    }

    AfterRender() {
        this.LoadImage().always(() => {
            this._isReady(true);
        });

        if (this._loginViaPlugin()) {
            let params: ILoginFormOnPageParams = {
                FormWrapperID: GuestPage.FORM_ID,
                LoginViaUserMenu: this._loginViaUserMenu(),
                LoginViaPlugin: this._loginViaPlugin(),
                OnlyLoginForm: this._onlyLoginForm(),
            };

            this._isDebugLoginForm &&
                console.log('AfterRender Guest Page --- For Plugin ---> Render LoginForm');
            this.Trigger(GUEST_HOME_PAGE_EVENTS.LOGIN_VIA_PLUGIN, params);
        } else if (!this._loginViaUserMenu() && !this._onlyLoginForm()) {
            this._isDebugLoginForm &&
                console.log(
                    'AfterRender Guest Page ---> Render LoginForm --- ',
                    'ViaUserMenu:',
                    this._loginViaUserMenu(),
                    ' OnlyLoginForm:',
                    this._onlyLoginForm()
                );
            let params: ILoginFormOnPageParams = {
                FormWrapperID: GuestPage.FORM_ID,
                LoginViaUserMenu: this._loginViaUserMenu(),
                LoginViaPlugin: null,
                OnlyLoginForm: this._onlyLoginForm(),
            };
            UserMenu.Instance.RenderLoginFormOnPage(params);
        } else if (this._onlyLoginForm()) {
            this._isDebugLoginForm &&
                console.log(
                    'AfterRender Guest Page ---> Render LoginForm --- ',
                    'OnlyLoginForm:',
                    this._onlyLoginForm()
                );
            let params: ILoginFormOnPageParams = {
                FormWrapperID: GuestPage.FORM_ID,
                LoginViaUserMenu: this._loginViaUserMenu(),
                LoginViaPlugin: null,
                OnlyLoginForm: this._onlyLoginForm(),
            };
            UserMenu.Instance.RenderLoginFormOnPage(params);
        }
    }

    RenderByTargetId(targetId: string) {
        this._container = document.getElementById(targetId);

        ko.cleanNode(this._container);
        ko.applyBindings(this, this._container);
    }

    Detach() {
        // this._loginViaUserMenu(null);
        // this._onlyLoginForm(null);
        ko.cleanNode(this._container);
        this._container.innerHTML = '';
    }

    private LoadImage() {
        const deferred = P.defer();

        const img = new Image();

        img.onload = () => {
            this._imageData(this._imageUrl);
            deferred.resolve(null);
        };
        img.onerror = () => {
            this._imageData(null);
            deferred.reject(null);
        };

        img.src = this._imageUrl;

        return deferred.promise();
    }

    FormatUrl() {
        if (Brand.Name === 'spheeres') {
            return 'https://spheeres.com';
        }

        if (Brand.Name === 'corsearch') {
            return 'https://corsearch.com/lp/brand-protection-case-management';
        }
        return null;
    }
}
